import { z } from 'zod';
/**
 * Toutes les PK du modèle sont des uuid v7, générées côté client (M7) : ordonnées dans le
 * temps, donc les index se comportent comme des entiers. Valider la version plutôt qu'un
 * uuid générique évite qu'un v4 s'infiltre — les deux formes sont valides, seule la version
 * diffère, et rien d'autre ne le détecterait avant une collision d'ordre en base.
 *
 * La fonction de génération que M7 exige est `newUuidV7`, juste en dessous.
 */
export const uuidV7Schema = z.uuid({ version: 'v7' });
/**
 * **La** fonction de génération de M7 (uuid v7, RFC 9562) : la tablette comme le serveur
 * l'appellent pour créer une PK. Écrite ici plutôt qu'importée — `packages/domain` ne dépend
 * que de zod (D17).
 *
 * ⚠️ `randomUUID()` rend un v4, que `uuidV7Schema` refuse : il ferait perdre l'ordonnancement
 * temporel dont dépendent les index (M7).
 */
export function newUuidV7() {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    // 48 bits d'horodatage en tête : ce préfixe croissant est ce qui garde l'index compact.
    const milliseconds = Date.now();
    for (let index = 0; index < 6; index++) {
        bytes[index] = (milliseconds / 2 ** (8 * (5 - index))) & 0xff;
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x70;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
//# sourceMappingURL=uuid.js.map